import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getDict } from "@/utils/dictionary";
import { toSQLLine, toLowerCase } from "@/utils/stringFun.js";
import { getSysDictionaryList } from "@/api/sysDictionary";
export default {
  name: "FieldDialog",
  props: {
    dialogMiddle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dbfdOptions: [],
      dictOptions: [],
      typeSearchOptions: [{
        label: "=",
        value: "="
      }, {
        label: "<>",
        value: "<>"
      }, {
        label: ">",
        value: ">"
      }, {
        label: "<",
        value: "<"
      }, {
        label: "LIKE",
        value: "LIKE"
      }],
      typeOptions: [{
        label: "字符串",
        value: "string"
      }, {
        label: "整型",
        value: "int"
      }, {
        label: "布尔值",
        value: "bool"
      }, {
        label: "浮点型",
        value: "float64"
      }, {
        label: "时间",
        value: "time.Time"
      }],
      rules: {
        fieldName: [{
          required: true,
          message: "请输入field英文名",
          trigger: "blur"
        }],
        fieldDesc: [{
          required: true,
          message: "请输入field中文名",
          trigger: "blur"
        }],
        fieldJson: [{
          required: true,
          message: "请输入field格式化json",
          trigger: "blur"
        }],
        columnName: [{
          required: true,
          message: "请输入数据库字段",
          trigger: "blur"
        }],
        fieldType: [{
          required: true,
          message: "请选择field数据类型",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    autoFill: function autoFill() {
      this.dialogMiddle.fieldJson = toLowerCase(this.dialogMiddle.fieldName);
      this.dialogMiddle.columnName = toSQLLine(this.dialogMiddle.fieldJson);
    },
    getDbfdOptions: function getDbfdOptions() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.dialogMiddle.dataType = "";
              _this.dialogMiddle.dataTypeLong = "";
              _this.dialogMiddle.fieldSearchType = "";
              _this.dialogMiddle.dictType = "";
              if (!_this.dialogMiddle.fieldType) {
                _context.next = 9;
                break;
              }
              _context.next = 7;
              return getDict(_this.dialogMiddle.fieldType);
            case 7:
              res = _context.sent;
              _this.dbfdOptions = res;
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var dictRes;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getSysDictionaryList({
              page: 1,
              pageSize: 999999
            });
          case 2:
            dictRes = _context2.sent;
            _this2.dictOptions = dictRes.data.list;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};